/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Denah_OkInputs */

const en_tut_denah_ok = /** @type {(inputs: Tut_Denah_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Once published, the new map is immediately visible to every member and the confirmation **Denah kantor diterbitkan.** appears.`)
};

const id_tut_denah_ok = /** @type {(inputs: Tut_Denah_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setelah terbit, peta baru langsung terlihat oleh semua anggota dan pesan **Denah kantor diterbitkan.** muncul.`)
};

/**
* | output |
* | --- |
* | "Once published, the new map is immediately visible to every member and the confirmation **Denah kantor diterbitkan.** appears." |
*
* @param {Tut_Denah_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_denah_ok = /** @type {((inputs?: Tut_Denah_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Denah_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_denah_ok(inputs)
	return en_tut_denah_ok(inputs)
});